var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingAwardDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 1.28125V10.9062C1.3125 11.2891 1.58594 11.5625 1.96875 11.5625H13.3438C13.6992 11.5625 14 11.8633 14 12.2188C14 12.6016 13.6992 12.875 13.3438 12.875H1.96875C0.875 12.875 0 12 0 10.9062V1.28125C0 0.925781 0.273438 0.625 0.65625 0.625C1.01172 0.625 1.3125 0.925781 1.3125 1.28125ZM8.75 7.84375C8.75 7.48828 9.02344 7.1875 9.40625 7.1875H10.8828L8.3125 4.61719L6.15234 6.77734C5.87891 7.05078 5.46875 7.05078 5.22266 6.77734L3.03516 4.58984C2.76172 4.34375 2.76172 3.93359 3.03516 3.66016C3.28125 3.41406 3.69141 3.41406 3.96484 3.66016L5.6875 5.38281L7.84766 3.22266C8.09375 2.97656 8.50391 2.97656 8.77734 3.22266L11.8125 6.28516V4.78125C11.8125 4.42578 12.0859 4.125 12.4688 4.125C12.8242 4.125 13.125 4.42578 13.125 4.78125V7.84375C13.125 8.22656 12.8242 8.5 12.4688 8.5H9.40625C9.02344 8.5 8.75 8.22656 8.75 7.84375Z",
    fill: "#D91734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingAwardDecline);
export default __webpack_public_path__ + "static/media/TrackingAwardDecline.dc5957e9c7d803bc7b9af99b2307d29f.svg";
export { ForwardRef as ReactComponent };